module.exports = __webpack_public_path__ + "static/img/product5.1115663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/purple/product5.png
// module id = vLGU
// module chunks = 0